import {LabeledTextInput} from "../../../../components/input/LabeledTextInput";
import {LabeledTimeZoneInput} from "../../../../components/input/LabeledTimeZoneInput";
import {RepeatStrategyEditor} from "./RepeatStrategyEditor";
import React, {useState} from "react";
import {ActionButton} from "../../../../util/UI/ActionButton";

type Props = {
  // If it's a delete we show "Delete recurring event" instead of "Edit recurring event"
  isDelete: boolean;
  onCancel: () => void;
  onConfirm: (updateFutureEvents: boolean) => void;
}

/**
 * When the user edits a recurring event this gets shown, asking if they
 * want to edit just this instance or every subsequent instance.
 *
 * Cancel is also an option.
 */
export const ConfirmEditPrompt = (props: Props) => {

  const [futureEvents, setFutureEvents] = useState(false);

  return (<div className="CalendarModalOverlay">
    <div className="CalendarModalContent">

      <h2>{props.isDelete ? 'Delete' : 'Edit'} recurring event</h2>

      <div className={'ThisOrFutureModalRow'} onClick={e => setFutureEvents(false)}>
        <input name='confirmEdit' type={'radio'}
               checked={!futureEvents}/>
        This event only
      </div>

      <div className={'ThisOrFutureModalRow'} onClick={e => setFutureEvents(true)}>
        <input name='confirmEdit' type={'radio'}
               checked={futureEvents}
               onChange={e => setFutureEvents(true)}/>
        This and following events
      </div>

      <br/>
      
      <div className={'Flex1 HorizontalFlex Gap20'}>
        <ActionButton secondary onClick={props.onCancel}>Cancel</ActionButton>
        <ActionButton onClick={() => props.onConfirm(futureEvents)}>Confirm</ActionButton>
      </div>
    </div>
  </div>);

}
